import React, { EffectCallback, FC, useCallback, useEffect, useState } from 'react'
import {
	GridUpBtnContainerStyled,
	GridUpBtnStyle,
} from 'LibNeo/components/Composite/Grids/GridUpBtn/styled'

interface UpBtnProps {
	show: boolean
	element: Element
}

export const GridUpBtn: FC<UpBtnProps> = ({ show, element }) => {
	const [hasScroll, setHasScroll] = useState<boolean>(true)

	const setScroll = (e): void => {
		if (e?.target?.scrollTop === 0) {
			setHasScroll(false)
			return undefined
		}
		if (show) setHasScroll(true)
	}

	useEffect((): EffectCallback => {
		element?.addEventListener('scroll', setScroll)
		return (): void => element?.removeEventListener('scroll', setScroll)
	}, [show, element])

	const onUpScroll = useCallback((): void => {
		element?.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
	}, [element])

	if (!show || !hasScroll) return null
	return (
		<GridUpBtnContainerStyled>
			<GridUpBtnStyle link onClick={onUpScroll} title="" iconAction="chevron-up-outline" />
		</GridUpBtnContainerStyled>
	)
}
